//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventDeletionLogReason, EventDeletionType } from './Enums';

export class EventDeleteOptions extends ItemBase {
    DeletionLogReason: EventDeletionLogReason = EventDeletionLogReason.AllEventsOnADay;
    DeletionType: EventDeletionType = EventDeletionType.All;
    NotificationNote: string | null = null;
    NotifyParentsByEmail: boolean = false;
    NotifyParentsBySMS: boolean = false;
    NotifyStudentsByEmail: boolean = false;
    NotifyStudentsBySMS: boolean = false;
    NotifyTeacherByEmail: boolean = false;
    NotifyTeacherBySMS: boolean = false;

    constructor(initializer?: Partial<EventDeleteOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "EventDeleteOptions";
}
